module.exports = __webpack_public_path__ + "img/Frame20.1b6596e1.png";